import * as Yup from 'yup';

import firstPartyDataSchema, {
  autoCompleteField,
} from '@components/UserOnboardingModal/ProfileFields/FirstPartyDataSchema';
import { BLANK_OPTION, BLANK_RECORD_OPTION } from '@utils/constants';

export const INITIAL_STATE = {
  company: BLANK_RECORD_OPTION,
  companySize: BLANK_OPTION,
  customIndustry: BLANK_RECORD_OPTION,
  customJobFunction: BLANK_RECORD_OPTION,
  customJobLevel: BLANK_RECORD_OPTION,
  customSubIndustry: BLANK_RECORD_OPTION,
  customSubJobFunction: BLANK_RECORD_OPTION,
  email: '',
  firstName: '',
  formVerification: true,
  industry: BLANK_OPTION,
  jobFunction: BLANK_OPTION,
  jobLevel: BLANK_OPTION,
  jobTitle: BLANK_RECORD_OPTION,
  lastName: '',
  postalCode: '',
  subIndustry: BLANK_OPTION,
  subJobFunction: BLANK_OPTION,
};

export const OPTIONAL_FIRST_PARTY_DATA = ['subJobFunction', 'organizationSubIndustry'];

export const potentialFirstPartyDataFields = [
  'company_name',
  'company_size',
  'email',
  'job_function',
  'job_level',
  'landing_page_id',
  'lead_type',
  'name',
  'newsletter_id',
  'organization_industry',
  'organization_sub_industry',
  'postal_code',
  'rc',
  'recaptcha_token',
  'slug',
  'sub_job_function',
  'title_at_company',
];

const fieldNameToSchemaMap = (fieldName) => {
  switch (fieldName) {
    case 'companyName':
      return 'company';
    case 'organizationIndustry':
      return 'industry';
    case 'organizationSubIndustry':
      return 'subIndustry';
    case 'titleAtCompany':
      return 'jobTitle';
    default:
      return fieldName;
  }
};

export const schema = (requiredFields) => {
  const firstPartySchema = firstPartyDataSchema({ isRequired: true });
  const formFieldsSchema = {
    ...firstPartySchema,
    company: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string().required('Please enter an organization'),
    }),
    email: Yup.string().required('Please enter an email'),
    firstName: Yup.string().required('Please enter a first name'),
    formVerification: Yup.bool().oneOf([true], 'You must agree to these terms before continuing'),
    jobTitle: Yup.object().shape({
      label: Yup.string(),
      value: Yup.mixed().required('Please enter a job title'),
    }),
    lastName: Yup.string().required('Please enter a last name'),
    subIndustry: autoCompleteField({ isRequired: false }),
    subJobFunction: autoCompleteField({ isRequired: false }),
  };
  const requiredFieldsSchema = requiredFields.reduce(
    (formSchema, formField) => {
      const fieldName = fieldNameToSchemaMap(formField);
      if (formField === 'name') {
        formSchema['firstName'] = formFieldsSchema.firstName;
        formSchema['lastName'] = formFieldsSchema.lastName;
      } else {
        formSchema[fieldName] = formFieldsSchema[fieldName];
      }
      return formSchema;
    },
    { email: formFieldsSchema.email, formVerification: formFieldsSchema.formVerification }
  );

  return Yup.object().shape(requiredFieldsSchema);
};
